import { Text, TextProps } from '@chakra-ui/react'

import { useAppStore } from '../../store/appStore/appStore'
import { createWidget } from '../widget-utils'

export type SavedViewNameWidgetProps = TextProps & {
  isLoading?: boolean
}

export const SavedViewNameWidget = ({
  isLoading,
  ...props
}: SavedViewNameWidgetProps) => {
  const savedViewName = useAppStore(
    ({ viewStore }) => viewStore.savedView?.name,
  )

  if (!savedViewName && !isLoading) {
    return null
  }

  return (
    <Text
      backgroundColor="presets.turquoise.10"
      border="1px solid"
      borderColor="presets.turquoise.50"
      color="presets.turquoise.50"
      fontSize="12px"
      fontWeight="600"
      padding="8px"
      marginLeft="8px"
      rounded="4px"
      {...props}
    >
      {savedViewName}
    </Text>
  )
}

export const SavedViewNameWidgetDefinition = createWidget(SavedViewNameWidget, {
  type: 'SavedViewName',
})
